import z from 'zod';

export function fileValidationSchema(
  acceptedTypes: readonly string[],
  maxSize: number,
) {
  return z
    .instanceof(File)
    .refine((file) => acceptedTypes.includes(file.type), {
      message: 'domain.termine.upload.error.fileType',
      params: {},
    })
    .refine((file) => file.size <= maxSize, {
      message: 'domain.termine.upload.error.size',
      params: { maxFileSize: (maxSize / 1024 / 1024).toFixed(1) },
    });
}
